import { render, staticRenderFns } from "./QuestionAddOrEdit.vue?vue&type=template&id=79cd2445&scoped=true"
import script from "./QuestionAddOrEdit.vue?vue&type=script&lang=js"
export * from "./QuestionAddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd2445",
  null
  
)

export default component.exports